export const VERIFY_LOCATION_MODAL = 'verifyLocation';
export const SAVE_LOCATION_MODAL = 'locationCard';
